module.exports = __webpack_public_path__ + "img/vip-bg.86f6f140.png";